import { useState, useEffect } from 'react';
import { projectURL } from './utils/mockdata';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js';
import { PolarArea } from 'react-chartjs-2';

// Register chart.js modules
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

// Utility to strip HTML tags
const stripHTML = (html) => {
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = html;
  return tempDiv.textContent || tempDiv.innerText || '';
};

const PolarAreaChart = () => {
  const [mxPost, setMxPost] = useState([]);

  const maxPostCreator = async () => {
    try {
      const postPath = projectURL + "dashboard/most-commented-posts";
      const postList = await fetch(postPath, {
        headers: { "cors": "no-cors" }
      });
      const postJson = await postList.json();
      const filteredPost = postJson.filter(item => item.commentsCount > 0);
      setMxPost(filteredPost);
    } catch (error) {
      console.error("Failed to fetch post data:", error);
    }
  };

  useEffect(() => {
    maxPostCreator();
  }, []);

  // Prepare labels (clean post text) and data (comment count)
  const maxPostDataName = mxPost.map(data => stripHTML(data.post));
  const maxPostCommentDataCount = mxPost.map(data => data.commentsCount);

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top',
      },
      title: {
        display: true,
        text: 'Top 5 Post Comments (Polar Area Chart)',
        titleAlign: 'center',
        color: '#333',
      },
    },
  };

  const data = {
    labels: maxPostDataName,
    datasets: [
      {
        label: 'Comments',
        data: maxPostCommentDataCount,
        backgroundColor: [
          'rgb(255, 160, 122)', 'rgb(218, 112, 214)', 'rgb(144, 238, 144)',
          'rgb(210, 105, 30)', 'rgb(135, 206, 250)', 'rgb(244, 164, 96)',
          'rgb(221, 160, 221)', 'rgb(152, 251, 152)', 'rgb(0, 206, 209)',
          'rgb(186, 85, 211)', 'rgb(175, 238, 238)', 'rgb(255, 228, 181)'
        ],
      },
    ],
  };

  return <PolarArea options={options} data={data} />;
};

export default PolarAreaChart;
